"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeMap = void 0;
/**
 * Simple map implementation that is the same as native Map.
 */
class IkeMap {
    constructor() {
        this._values = {};
    }
    get(key) {
        return this._values[key];
    }
    set(key, value) {
        this._values[key] = value;
    }
    has(key) {
        return this._values[key] != null;
    }
    keys() {
        return Object.keys(this._values);
    }
    values() {
        const keys = Object.keys(this._values);
        const output = [];
        for (const key of keys) {
            output.push(this._values[key]);
        }
        return output;
    }
    clear() {
        this._values = {};
    }
    delete(key) {
        delete this._values[key];
    }
    get size() {
        return this.keys().length;
    }
}
exports.IkeMap = IkeMap;
//# sourceMappingURL=ike.map.js.map